import {JColors} from 'themes/colors';

export const Status = {
  DEFAULT: JColors.veryLightPink,
  PENDING: JColors.reddishOrange,
  DELIVERED: JColors.reddishOrange,
  DROPOFF_SUCCEEDED: JColors.darkPastelGreen,
  SUCCEEDED: JColors.darkPastelGreen,
  FAILED: JColors.dustyRed,
};

const styles = {
  accessLabel: {
    fontFamily: 'AvenirNext',
    fontSize: '12px',
    color: '#297a48',
  },
  accessCodeContainer: {
    padding: '7px 10px',
    borderRadius: '5px',
    border: '1px solid #297a48',
    flex: 1,
  },
  codeBlock: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grayBtn: {
    border: '1px solid #ccc',
    color: '#8d8d8d',
  },
  container: {
    marginBottom: '16px',
  },
  panelContainer: {
    backgroundColor: '#f4f4f4',
    boxShadow: 'none',
  },
  panelHeader: {
    padding: '8px',
    minHeight: 'auto !important',
    '& > .MuiExpansionPanelSummary-content': {
      margin: '0px',
    },
  },
  panelHeaderTitle: {
    flex: 1,
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    color: '#000',
  },
  panelHeaderStatus: {
    fontSize: '12px',
    fontStyle: 'italic',
    margin: '0 5px',
  },
  panelToggleIcon: {
    padding: '4px 12px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  panelBody: {
    padding: '8px',
    fontSize: '12px',
  },
  noteLabel: {
    fontFamily: 'AvenirNext',
    fontSize: '10px',
    color: '#bec6d8',
  },
  noteContent: {
    borderRadius: '5px',
    border: 'solid 1px #bec6d8',
    padding: '7px 10px',
    fontStyle: 'italic',
    fontSize: '12px',
  },
  text: {
    fontSize: '12px',
    color: '#000',
  },
  text2: {
    fontSize: '9px',
  },
  remarkHeader: {
    fontSize: '10px',
  },
  remarkHeaderStatus: {
    fontFamily: 'AvenirNext-DemiBold',
    flex: 1,
  },
  remarkHeaderTime: {
    fontFamily: 'AvenirNext-Medium',
  },
  remarkContent: {
    padding: '8px 12px',
    borderRadius: '5px',
    border: '1px solid #cfcfcf',
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'italic',
  },
  timeWindow: {
    backgroundColor: '#FFF',
    padding: '7px 15px',
    borderRadius: '5px',
    margin: '12px 0px',
  },
  timeLabel: {
    fontFamily: 'AvenirNext-DemiBold',
    color: '#96979a',
  },
  // Keeps TimeWithTimezone text at the panel's own size/color
  timeValue: {
    fontSize: 'inherit',
    color: 'inherit',
  },
  dropoffAccessContentLabel: {
    // This style was used inline in the component
  },
  paragraph: {
    fontSize: '12px',
    color: '#000',
  },
};

export default styles;
